import { Icon, styled } from "@mui/material";
import React from "react";

const StyledIcon = styled(({ children, ...props }) => (
  <Icon {...props}>{children}</Icon>
))(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const CustomIcon = ({ svgIcon, imgStyles, ...others }) => {
  return (
    <StyledIcon {...others}>
      <img src={svgIcon} alt="icon" {...imgStyles} />
    </StyledIcon>
  );
};

export default CustomIcon;
